// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ho-z","badgeLink":"io-z","category":"jo-z"};